import React from 'react';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
} from '@mui/material';

const AvatarCard = ({ avatar, isSelected, onSelect }) => {
  const getStyleColor = (style) => {
    return style === 'realistic' ? '#14B8A6' : '#A855F7';
  };

  const genderChipStyles = (gender) => {
    if (!gender) return {};
    return gender.toLowerCase() === 'male'
      ? {
          backgroundColor: '#E0F2FE',
          color: '#0369A1',
        }
      : {
          backgroundColor: '#FCE7F3',
          color: '#BE185D',
        };
  };

  return (
    <Card
      onClick={() => onSelect(avatar)}
      sx={{
        cursor: 'pointer',
        position: 'relative',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        borderRadius: 3,
        overflow: 'hidden',
        width: '100%',
        border: `2px solid ${isSelected ? '#DC2626' : 'rgba(148, 163, 184, 0.18)'}`,
        boxShadow: isSelected
          ? '0 18px 45px rgba(15, 23, 42, 0.14)'
          : '0 10px 28px rgba(15, 23, 42, 0.08)',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.14)',
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={
            avatar.image
              ? `${avatar.image}`
              : '/images/avatar-list/default-avatar.png'
          }
          alt={avatar.groupName}
          sx={{
            objectFit: 'cover',
            backgroundColor: 'grey.100',
            width: '100%',
            height: {
              xs: 230,
              sm: 230,
              md: 270,
            },
          }}
        />

        <Chip
          label={avatar.style === 'realistic' ? 'Realistic' : 'Animated'}
          size="small"
          sx={{
            position: 'absolute',
            top: 16,
            left: 16,
            px: 1.75,
            py: 0.5,
            borderRadius: '999px',
            backgroundColor: getStyleColor(avatar.style),
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            boxShadow: '0 12px 30px rgba(20, 184, 166, 0.18)',
          }}
        />

      </Box>

      <CardContent sx={{ p: 2.5, pt: 3, bgcolor: '#fff' }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: '1rem',
            mb: 1,
            color: 'text.primary',
          }}
        >
          {avatar.groupName}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
          {avatar.gender && (
            <Chip
              label={avatar.gender}
              size="small"
              sx={{
                ...genderChipStyles(avatar.gender),
                fontWeight: 700,
                fontSize: '0.72rem',
                height: 26,
                pl: 1.25,
                pr: 1.25,
                borderRadius: '999px',
                textTransform: 'capitalize',
              }}
            />
          )}

          {avatar.accent && (
            <Chip
              label={avatar.accent}
              size="small"
              sx={{
                backgroundColor: '#EEF2FF',
                color: '#3730A3',
                fontWeight: 700,
                fontSize: '0.72rem',
                height: 26,
                pl: 1.25,
                pr: 1.25,
                borderRadius: '999px',
              }}
            />
          )}
        </Box>

        {avatar.age && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.86rem' }}
          >
            Age: {avatar.age}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default AvatarCard;
